import React from 'react';
import styled from 'styled-components';
import Footer from 'components/commons/Footer';
import colors from 'theme/colors';
import LandingHeader from './LandingHeader';
import HeroSection from './HeroSection';
import FeeSection from './FeeSection';
import HowItWorksSection from './HowItWorksSection';
import EcosystemSection from './EcosystemSection';
import AffiliateSection from './AffiliateSection';
import FaqSection from './FaqSection';
import ClosingSection from './ClosingSection';

export default function ThreeYearsLandingPage() {
    return (
        <Page>
            <LandingHeader />
            <HeroSection />
            <FeeSection />
            <HowItWorksSection />
            <AlternateBg>
                <EcosystemSection />
                <AffiliateSection />
            </AlternateBg>
            <FaqSection />
            <ClosingSection />
            <Footer />
        </Page>
    );
}

const Page = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${colors.neutralLight};
    overflow-x: hidden;
`;

const AlternateBg = styled.div`
    background: ${colors.neutralBackground};
`;
